<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      row
      wrap>
      <v-flex
        d-flex
        xs12
        md8>
        <v-layout
          row
          wrap>
          <v-flex
            d-flex
          >
            <material-card
              color="general"
              title="Edit Account Detail"
              text="Complete your account detail"
            >
              <v-form
                id="form1-vue"
                ref="form1"
                v-model="valid1"
                :lazy-validation="lazyValidation1"
              >
                <v-container py-0>
                  <v-layout wrap>
                    <v-flex
                      xs12
                      md4
                    >
                      <v-text-field
                        :value="companyName"
                        label="Company"
                        prepend-icon="mdi-office-building"
                        disabled/>
                    </v-flex>
                    <v-flex
                      xs12
                      md4
                    >
                      <v-text-field
                        :value="userLogin.username"
                        class="purple-input"
                        label="User Login"
                        prepend-icon="mdi-account"
                        disabled
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      md4
                    >
                      <v-text-field
                        v-model="userLogin.employee.firstName"
                        :rules="[rules.required,rules.max50chars]"
                        label="Full Name"
                        prepend-icon="mdi-rename-box"
                        counter
                        required
                        class="purple-input"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      md4
                    >
                      <v-text-field
                        v-model="userLogin.employee.email"
                        :rules="[rules.required,rules.max50chars, rules.email]"
                        type="text"
                        label="Email"
                        prepend-icon="mdi-email"
                        counter
                        required
                        class="purple-input"
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      md4
                    >
                      <v-text-field
                        v-model="userLogin.employee.phoneNo"
                        :rules="[rules.required,rules.number]"
                        label="Phone No"
                        prepend-icon="mdi-phone"
                        required
                        class="purple-input"/>
                    </v-flex>
                    <v-flex
                      xs12
                      text-xs-right
                    >
                      <v-btn
                        color="warning"
                        @click="reset"
                      >
                        Clear Form
                      </v-btn>
                      <v-btn
                        :disabled="!valid1"
                        :dark="valid"
                        class="mx-0 font-weight-light"
                        color="general"
                        @click="saveAccDetail"
                      >
                        Update Account
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </material-card>
          </v-flex>
          <v-flex d-flex>
            <material-card
              color="general"
              title="Edit Password Account"
              text="Complete your password change"
            >
              <v-form
                id="form-vue"
                ref="form"
                v-model="valid"
                :lazy-validation="lazyValidation"
              >
                <v-container py-0>
                  <v-layout wrap>
                    <v-flex
                      xs12
                      md4
                    >
                      <v-text-field
                        :value="companyName"
                        label="Company"
                        prepend-icon="mdi-office-building"
                        disabled/>
                    </v-flex>
                    <v-flex
                      xs12
                      md4
                    >
                      <v-text-field
                        :value="userLogin.username"
                        class="purple-input"
                        label="User Login"
                        prepend-icon="mdi-account"
                        disabled
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      md4
                    >
                      <v-text-field
                        v-model="userLogin.oldPassword"
                        :rules="[rules.required,rules.max50chars]"
                        :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                        :type="showPassword ? 'text' : 'password'"
                        label="Old Password"
                        prepend-icon="mdi-lock"
                        placeholder="*********"
                        counter
                        required
                        class="purple-input"
                        @click:append="showPassword = !showPassword"/>
                    </v-flex>
                    <v-flex
                      xs12
                      md6
                    >
                      <v-text-field
                        v-model="userLogin.password"
                        :rules="[rules.required,rules.max50chars]"
                        :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                        :type="showPassword ? 'text' : 'password'"
                        label="New Password"
                        prepend-icon="mdi-lock"
                        placeholder="*********"
                        counter
                        required
                        class="purple-input"
                        @click:append="showPassword = !showPassword"/>
                    </v-flex>
                    <v-flex
                      xs12
                      md6
                    >
                      <v-text-field
                        v-model="userLogin.confirmPassword"
                        :rules="[rules.required,rules.max50chars,passwordConfirmationRule]"
                        :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                        :type="showPassword ? 'text' : 'password'"
                        label="Confirm Password"
                        prepend-icon="mdi-lock"
                        placeholder="*********"
                        counter
                        required
                        class="purple-input"
                        @click:append="showPassword = !showPassword"/>
                    </v-flex>
                    <v-flex
                      xs12
                      text-xs-right
                    >
                      <v-btn
                        color="warning"
                        @click="reset"
                      >
                        Clear Form
                      </v-btn>
                      <v-btn
                        :disabled="!valid"
                        :dark="valid"
                        class="mx-0 font-weight-light"
                        color="general"
                        @click="save"
                      >
                        Change Password
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </material-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex
        xs12
        md4
      >
        <material-card class="v-card-profile">
          <v-avatar
            slot="offset"
            class="mx-auto d-block"
            size="130"
          >
            <div id="profileImage">{{ userLogin.username.substr(0,1).toUpperCase() }}</div>
          </v-avatar>
          <v-card-text class="text-xs-center">
            <h6 class="category text-gray font-weight-thin mb-3">PT. Ornova Integra Solusi</h6>
            <h4 class="card-title font-weight-light">{{ user.fullname }}</h4>
            <p class="card-description font-weight-light">We are PT Ornova Integra Solusi, an engineering company which
            is specializes in Machine Vision and Control. Established by an expert team, who have success in
            engineering field. They provide a solution base on field case. PT Ornova Integra Solusi has quickly
            gained trust from multinational company due their performance in supporting and providing solution for the
            user.</p>
            <!--            <v-btn-->
            <!--              color="general"-->
            <!--              round-->
            <!--              class="font-weight-light"-->
            <!--            >Follow</v-btn>-->
          </v-card-text>
        </material-card>
      </v-flex>

      <v-snackbar
        v-model="snackbar"
        :color="color"
        :top="true"
      >
        {{ snackMessage }}
        <v-btn
          dark
          flat
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
export default {
  name: 'ProfileAccount',
  data () {
    return {
      snackbar: false,
      snackMessage: '',
      valid: false,
      lazyValidation: false,
      valid1: false,
      lazyValidation1: false,
      companyName: 'PT. Ornova Integra Solusi',
      userLogin: {
        username: localStorage.getItem('username'),
        password: '',
        oldPassword: '',
        confirmPassword: '',
        employee: {
          firstName: '',
          email: '',
          phoneNo: ''
        }
      },
      errorMessages: 'Old Password Wrong!',
      color: 'general',
      showPassword: false,
      rules: {
        required: value => !!value || 'Required',
        number: value => !isNaN(value) || 'Must be numeric',
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }
  },
  computed: {
    passwordConfirmationRule () {
      return (this.userLogin.password === this.userLogin.confirmPassword) || 'New & Confirm Password must match'
    },
    ...mapState(['user'])
  },
  created () {
    this.getAccDetail()
  },
  methods: {
    reset () {
      this.$refs.form.resetValidation()
      this.$refs.form1.resetValidation()
      this.userLogin = {
        username: localStorage.getItem('username'),
        password: '',
        oldPassword: '',
        confirmPassword: '',
        employee: {
          firstName: '',
          email: '',
          phoneNo: ''
        }
      }
    },
    async getAccDetail () {
      try {
        let response = await this.$http.get(`api/employee/${this.user.username}`)
        this.userLogin.employee = response.data
      } catch (error) {
        console.log(error)
      }
    },
    async saveAccDetail () {
      if (!this.$refs.form1.validate()) {
        console.log('validation fail direct')
        return false
      }
      // if (this.$refs.form.validate()) {
      //   console.log('validation success')
      // }
      let tableItem = this.userLogin
      let endpoint = `api/userlogin/account`
      let method = 'patch'
      try {
        let resp = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
        if (resp.data.message === 'SUCCESS') {
          this.snackbar = true
          this.color = 'success'
          this.snackMessage = 'Success Update Account!'
          return true
        }
        throw new Error(resp.data.details)
      } catch (error) {
        console.log(error)
        this.snackbar = true
        this.color = 'error'
        this.snackMessage = 'Update Account Fail!'
      }
    },
    async save () {
      if (!this.$refs.form.validate()) {
        console.log('validation fail direct')
        return false
      }
      // if (this.$refs.form.validate()) {
      //   console.log('validation success')
      // }
      let tableItem = this.userLogin
      let endpoint = `api/userlogin/password`
      let method = 'patch'
      try {
        let resp = await this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
        if (resp.data.message === 'SUCCESS') {
          this.snackbar = true
          this.color = 'success'
          this.snackMessage = 'Success Change Password!'
          return true
        }
        throw 'error'
      } catch (error) {
        console.log(error)
        this.snackbar = true
        this.color = 'error'
        this.snackMessage = 'Change Password Fail!'
      }
    }
  }

}
</script>

<style scoped>
  #profileImage {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background: #295ba8;
    font-size: 35px;
    color: #fff;
    text-align: center;
    line-height: 150px;
    margin: 20px 0;
  }
</style>
